'use client'

import { SnackbarContainer } from '@b-stock/fe-core/bstock-react'

import { GlobalResets } from '@/styles/globalResets'

export const ClientContainers = () => {
  return (
    <>
      <GlobalResets />
      <SnackbarContainer />
    </>
  )
}
